import React, { useEffect, useState } from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import "../CSS/waitlistLandingPage.css";
import Meta from "../Components/Meta.js";
import { getBikeByName, getAllBikes } from "../Actions/bikeActions.js";
import { useDispatch, useSelector } from "react-redux";
import ModalMobile from "../Components/ModalMobile.js";
import { Link } from "react-router-dom";
import bluelogo from "../images/EM-LOGO_Blue.png";

function WaitlistLandigPage() {
  return (
    <>
      <Meta
        title={"Buy Latest EMotorad Electric Bicycle | Latest Collection"}
        description={
          "Get ahead with the latest EMotorad electric bicycles. Our new collection offers enhanced features, superior comfort, and unmatched performance."
        }
      />
      <div className="w-100 logo-bar">
        <div className=" desktop-nav m-0 p-0 p-3 ps-lg-5 pe-lg-5 ">
          <div className="d-flex justify-content-center ">
            <img
              src={bluelogo}
              className="img-fluid"
              style={{ width: "170px" }}
              alt=""
            />
          </div>
        </div>
      </div>
      <div className="position-relative">
        <picture>
          <source
            media="(max-width:650px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/prebook25Mobile.jpg"
          />
          <source
            media="(min-width:651px)"
            srcSet="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/prebook25.jpg"
          />
          <img
            src="https://ar-euro.s3.ap-south-1.amazonaws.com/india-webiste-17-02-24/landing+page/prebook25.jpg"
            className="img-fluid w-100"
            alt=""
            srcSet=""
          />
        </picture>
        <div className="position-absolute kalki-banner-btn">
          <ModalMobile
            className="kalki-btn py-3 px-4 px-lg-5"
            text="PRE-BOOK NOW @ ₹1999"
          />
        </div>
      </div>
      <div
        className="background-em d-lg-none position-sticky p-2"
        style={{
          bottom: "0%",
          border: "0px",
          width: "100%",
          zIndex: "2",
        }}
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{
            gap: "1.5em",
            bottom: "0%",
            border: "0px",
            width: "100%",
            zIndex: "2",
          }}
        >
          <div className="" style={{ width: "100%" }}>
            <ModalMobile
              className="fix-btn btn p-2 py-3 fw-bold w-100 btn-light d-block ms-auto text-em border-0"
              text="PRE-BOOK NOW"
            />
          </div>
        </div>
      </div>
      <Footer></Footer>
    </>
  );
}

export default WaitlistLandigPage;
